export default "/assets/images/app-showcase-05.jpg?e942189eeda1620a408f2a871a3dfd1f";